import React from 'react';
import { Box, Center, LeftArrow, Overlay, RightArrow } from '..';
import _ from 'lodash';
import {
  CarouselContentWrapper,
  CarouselImageWrapper,
  CarouselWrapper,
} from './shared-components';

export const CarouselImage = (props) => {
  let { handlePrevious, handleNext, index, length, images } = props;
  return (
    <CarouselImageWrapper>
      <CarouselWrapper>
        <CarouselContentWrapper index={index} length={length}>
          {_.flow((images) =>
            _.map(images, (image) => {
              return <Box ratio={0.25} backgroundImage={image} />;
            })
          )(images)}
        </CarouselContentWrapper>
      </CarouselWrapper>

      <Overlay height="100%" left={4} top={0}>
        <Center>
          <LeftArrow onClick={handlePrevious} />
        </Center>
      </Overlay>
      <Overlay height="100%" right={4} top={0}>
        <Center>
          <RightArrow onClick={handleNext} />
        </Center>
      </Overlay>
    </CarouselImageWrapper>
  );
};
